import React, { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import packageJson from "../../package.json";

const webCommandAPI = packageJson["web-command-api"];

function HandleJsonUpload() {
  const [showNotification, setShowNotification] = useState(false);
  const { t } = useTranslation();
  const [isExecuting, setIsExecuting] = useState(false);

  const inputRef3 = useRef(null);
  const handleInputClick3 = () => {
    if (inputRef3.current) {
      inputRef3.current.select();
      document.execCommand("copy");
      setShowNotification(true);
      setTimeout(() => {
        setShowNotification(false);
      }, 2000); // Hide notification after 2 seconds
    }
  };



  const [file, setFile] = useState(null);
  const [uploadedFileName, setUploadedFileName] = useState("");

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file.size > 5 * 1024 * 1024) {
      // Giới hạn 5MB
      alert("Upload limit is 5MB !");
    } else {
      setFile(file);
    }
  };

  const handleUpload = async () => {
    if (!file) {
      alert("Please select a file to upload.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await fetch(`${packageJson.proxy}/upload`, {
        method: "POST",
        body: formData, // Gửi dữ liệu dưới dạng FormData
      });

      const data = await response.json();
      setUploadedFileName(data.fileName);
      alert("File uploaded successfully!");
    } catch (err) {
      console.error("Error uploading file:", err);
      alert("Failed to upload file.");
    }
  };

  // Hàm xử lý nút Execute
  const handleExecute = () => {
    if (isExecuting) return;
    setIsExecuting(true);

    try {
      const savedKey = sessionStorage.getItem("playerKey");
      if (!savedKey) return;

      if (!uploadedFileName) return;

      let commandValue = `/json ${packageJson.proxy}/${uploadedFileName}`;
      if (commandValue.startsWith("/")) {
        commandValue = commandValue.substring(1);
      }

      const encodedCommand = encodeURIComponent(commandValue);
      const url = `${webCommandAPI}/excute/${savedKey}/${encodedCommand}`;

      fetch(url, { mode: "no-cors" })
        .then((res) => res.text())
        .catch(() => { });
    } catch (_) { }

    setTimeout(() => {
      setIsExecuting(false);
    }, 5000);
  };

  return (
    <div className="max-w-4xl mx-auto space-y-8 p-4">
      {/* Header */}
      <div className="grid grid-cols-1 md:grid-cols-12 gap-4 items-center">
        <div className="md:col-span-12">
          <h2 className="text-xl font-bold text-astral-purple">{t("jsonupload")}</h2>
        </div>
      </div>

      {/* Upload Section */}
      <div className="glass-panel p-6 border border-white/5 rounded-xl space-y-6">
        <div className="flex flex-col md:flex-row gap-4 items-center">
          <div className="flex-1 w-full relative">
            <input
              type="file"
              accept=".json"
              id="file-upload"
              className="hidden"
              onChange={handleFileChange}
            />
            <label
              htmlFor="file-upload"
              className={`
                flex items-center justify-between w-full px-4 py-3 rounded-lg border-2 border-dashed cursor-pointer transition-all
                ${file
                  ? "border-stardust-gold/50 bg-stardust-gold/5 text-stardust-gold-light"
                  : "border-white/10 bg-white/5 text-gray-400 hover:border-astral-purple/50 hover:text-white"
                }
              `}
            >
              <span className="truncate">{file ? file.name : t("select_file") || "Choose JSON file..."}</span>
              <svg className="w-5 h-5 ml-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
              </svg>
            </label>
          </div>
          <div>
            <button
              onClick={handleUpload}
              disabled={!file}
              className={`
                px-8 py-3 rounded-lg font-bold shadow-lg transition-all duration-200 whitespace-nowrap
                ${!file
                  ? "bg-gray-600/50 text-gray-400 cursor-not-allowed"
                  : "bg-gradient-to-r from-astral-purple to-indigo-600 text-white hover:shadow-indigo-500/30 hover:scale-105 active:scale-95"
                }
              `}
            >
              Upload
            </button>
          </div>
        </div>
      </div>

      {/* Command Section */}
      {uploadedFileName && (
        <div className="space-y-4">
          <h2 className="text-xl font-bold text-astral-purple">{t("command")}</h2>

          <div className="glass-panel p-6 border border-white/5 rounded-xl">
            <div className="flex flex-col md:flex-row gap-4">
              <div className="flex-1">
                <div className="relative group">
                  <input
                    type="text"
                    value={`/json ${packageJson.proxy}/${uploadedFileName}`}
                    readOnly
                    ref={inputRef3}
                    className="glass-input font-mono text-sm w-full pl-4 pr-10 py-3 group-hover:bg-white/5 transition-colors"
                    onClick={handleInputClick3}
                  />
                  <div className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"></path></svg>
                  </div>
                </div>
              </div>
              <div>
                <button
                  className="glass-button-primary w-full md:w-auto px-8"
                  onClick={handleExecute}
                  disabled={isExecuting}
                >
                  {isExecuting ? "Executing..." : "Execute"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showNotification && (
        <div className="fixed top-5 left-1/2 transform -translate-x-1/2 bg-green-500/90 text-white px-6 py-2 rounded-full shadow-xl z-50 animate-in fade-in slide-in-from-top-4">
          {t("copySuccess")}
        </div>
      )}
      <div className="h-24"></div>
    </div>
  );
}

export default HandleJsonUpload;
